import React, { Component } from 'react';
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button
} from "reactstrap";

class DeleteIconConfirmationModal extends Component {
  state = {  }
  render() { 
    return ( <Modal
      isOpen={this.props.isOpen}
      toggle={() => this.props.toggle("cancel")}
    >
      <ModalHeader toggle={() => this.props.toggle("cancel")}>
        Delete Confirmation
      </ModalHeader>
      <ModalBody>
        <div>         
            <p>
              Are you sure to delete "{this.props?.data?.name}" ?
            </p>        
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          className="modalBtnCancel"
          onClick={() => this.props.toggle("cancel")}
        >
          No
        </Button>
        <Button
          className="modalBtnSave"
          onClick={(e) => this.props.toggle("delete")}
        >
          Yes, Delete
        </Button>
      </ModalFooter>
    </Modal> );
  }
}
 
export default DeleteIconConfirmationModal;